import { render, staticRenderFns } from "./crowd-flow.vue?vue&type=template&id=5a52d7f2&scoped=true&"
import script from "./crowd-flow.vue?vue&type=script&lang=ts&"
export * from "./crowd-flow.vue?vue&type=script&lang=ts&"
import style0 from "./crowd-flow.vue?vue&type=style&index=0&id=5a52d7f2&prod&scoped=true&lang=scss&"
import style1 from "./crowd-flow.vue?vue&type=style&index=1&id=5a52d7f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a52d7f2",
  null
  
)

export default component.exports